import { Inject, Injectable } from '@angular/core';
import {
    LAYOUT_CONFIG,
    LayoutConfigOptions,
    LayoutGapParent,
    LayoutGapStyleBuilder,
    StyleDefinition,
    StyleUtils,
} from '@angular/flex-layout';

/**
 * When an element only declares responsive gaps (e.g. `fxLayoutGap.lt-sm`), flex-layout's
 * MediaMarshaller still re-applies the gap on child mutations while that breakpoint is
 * inactive, passing an undefined value straight into the style builder. Skipping empty
 * values keeps that path from throwing without changing any applied gap.
 */
@Injectable({ providedIn: 'root' })
export class SafeLayoutGapStyleBuilder extends LayoutGapStyleBuilder {
    constructor(styler: StyleUtils, @Inject(LAYOUT_CONFIG) config: LayoutConfigOptions) {
        super(styler, config);
    }

    override buildStyles(gapValue: string, parent: LayoutGapParent): StyleDefinition {
        return gapValue ? super.buildStyles(gapValue, parent) : {};
    }

    override sideEffect(gapValue: string, styles: StyleDefinition, parent: LayoutGapParent): void {
        if (gapValue) {
            super.sideEffect(gapValue, styles, parent);
        }
    }
}
